import React, { useState, useEffect } from "react";
import { Breadcrumb, BreadcrumbItem, FormInput, Row, Col } from "shards-react";
import {
    CardCustomized,
    CardHeaderCustomized
} from "../../components/cards/card-width-title/style";
import DeleteLink from "./delete-link/DeleteLink";
import Loading from "../../components/loading/Loading";
import AddButton from "../../components/buttons/add-button/AddButton";
import { GenericAlert } from "../../components/alert/GenericAlert";
import RoleService from "../../services/role-services/RoleService";
import AuthService from "../../services/auth-service/AuthService";
import withLabelAndHelpText from "../../components/inputs/hocs/with-label-and-helptext/withLabelAndHelpText";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

import {
    AgGridContainerRow,
    AgGridContentBox
} from "../../components/ag-grid-utils/styles";
import {
    ResponsiblePrimaryButton,
    ResponsibleSecondaryButton
} from "../../components/buttons/ResponsibleAmeButton";
import { StyledAgGridContainer } from "./styles";
import UserPermissionsCardComponent from "../../components/common/check-box-group-component/user-permissions-card-component/UserPermissionsCardComponent";
import {
    ButtonGroup,
    StyledResponsiblePrimaryButton,
    DeleteBox,
    DeleteText
} from "./styles";
import useStatus from "../../hooks/useStatus";
import useForm from "../../hooks/useForm";
import { useMountBreadCrumb } from "../../hooks/useMountBreadCrumb";
import { Link } from "react-router-dom";

const InputWithLabel = withLabelAndHelpText(FormInput);

const RoleView = () => {
    const initialRole = {
        id: "",
        name: "",
        scopes: []
    };
    const initialAlertInfo = { theme: "", message: "", visible: false };
    const [roles, setRoles] = useState([initialRole]);
    const [originalScopes, setOriginalScopes] = useState([]);
    const [role, setRole] = useState(initialRole);
    const [isDiffScopes, setIsDiffScopes] = useState(false);
    const [isDiffName, setIsDiffName] = useState(false);
    const [isRoleBoxVisible, setIsRoleBoxVisible] = useState(false);
    const [showAddRoleContent, setShowAddRoleContent] = useState(false);
    const [showAskToDelete, setShowAskToDelete] = useState(false);
    const [isCreateAvailable, setIsCreateAvailable] = useState(false);
    const [title, setTitle] = useState("Defina uma role para editar");
    const [, setGridApi] = useState(null);
    const [, setGridColumnApi] = useState(null);
    const { status, setAllStatus } = useStatus();
    const { values, setValue, setAllValues } = useForm({ roleName: "" });
    const [alertInfo, setAlertInfo] = useState(initialAlertInfo);
    const [buttonLabel, setButtonLabel] = useState("");

    useEffect(() => {
        findRoles();
        const scopes = AuthService.getDecodedToken().scopes;
        setIsCreateAvailable(
            scopes.filter(scope => scope === "write_role").length > 0
        );
    }, []);

    const onGridReady = params => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

        params.api.sizeColumnsToFit();
        window.addEventListener("resize", function() {
            setTimeout(function() {
                params.api.sizeColumnsToFit();
            });
        });

        params.api.sizeColumnsToFit();
    };
    const findRoles = async () => {
        try {
            setAllStatus({ isFetching: true, succes: false, error: false });
            const roles = await RoleService.getRoles();
            setRoles(roles.data);
            setAllStatus({ isFetching: false, succes: true, error: false });
        } catch (e) {
            console.error("Não foi possível achar roles");
            setAlertInfo({
                theme: "danger",
                message: "Ops! Não recuperamos as roles. Tente mais tarde.",
                visible: true
            });
            setAllStatus({ isFetching: false, succes: false, error: true });
        }
    };

    const askToDeleteRole = role => {
        setShowAskToDelete(true);
        setRole(role);
    };

    const deleteRole = async () => {
        try {
            setAllStatus({ isFetching: true, succes: false, error: false });
            await RoleService.deleteRole(role);
            const roles = await RoleService.getRoles();
            setRoles(roles.data);
            setAllStatus({ isFetching: false, succes: true, error: false });
            setAlertInfo({
                theme: "success",
                message: "Deletamos a role com sucesso.",
                visible: true
            });
        } catch (e) {
            console.error("Não foi possível deletar a role");
            setAllStatus({ isFetching: false, succes: false, error: true });
            setAlertInfo({
                theme: "danger",
                message: "Ops! Não deletamos a role. Tente mais tarde.",
                visible: true
            });
        } finally {
            setShowAskToDelete(false);
        }
    };

    const selectRoleToEdit = clickedRole => {
        setOriginalScopes(clickedRole.scopes);
        setTitle(`Escopos da role: ${clickedRole.name}`);
        setButtonLabel("Salvar");
        setRole(clickedRole);
        const updatedValues = { ...values, roleName: clickedRole.name };
        setAllValues(updatedValues);
        setIsRoleBoxVisible(true);
    };

    const editRole = async () => {
        try {
            setAllStatus({ isFetching: true, succes: false, error: false });

            const editedRole = {
                id: role.id,
                name: values.roleName,
                scopes: role.scopes
            };
            await RoleService.editRole(editedRole);
            updateLocalRoles();
            setAllStatus({ isFetching: false, succes: true, error: false });
            setAlertInfo({
                theme: "success",
                message: "Atualizamos os escopos da role.",
                visible: true
            });
        } catch (e) {
            console.error("Não possível editar a role");
            setAllStatus({ isFetching: false, succes: false, error: true });
            setAlertInfo({
                theme: "danger",
                message:
                    "Ops! Não atualizamos os escopos da role. Tente mais tarde.",
                visible: true
            });
        }
    };

    const updateLocalRoles = async () => {
        const roles = await RoleService.getRoles();
        setRoles(roles.data);
        setOriginalScopes(roles.data.scopes);
        setIsDiffScopes(false);
    };

    const handleUserSwitchChange = name => {
        const roleDeepClone = JSON.parse(JSON.stringify(role));
        !roleDeepClone.scopes.includes(name)
            ? roleDeepClone.scopes.push(name)
            : roleDeepClone.scopes.splice(
                  roleDeepClone.scopes.indexOf(name),
                  1
              );
        setRole(roleDeepClone);
        checkScopesDiff(roleDeepClone.scopes);
    };

    const selectAddNewRole = () => {
        const updatedValues = { ...values, roleName: "" };
        setAllValues(updatedValues);
        setTitle("Defina os escopos da nova role");
        setShowAddRoleContent(true);
        setRole(initialRole);
        setButtonLabel("Criar role");
        setIsDiffScopes(false);
        setOriginalScopes([]);
    };

    const createRole = async () => {
        try {
            setAllStatus({ isFetching: true, succes: false, error: false });
            const newRole = {
                name: values.roleName,
                scopes: role.scopes
            };
            await RoleService.createRole(newRole);
            updateLocalRoles();
            setShowAddRoleContent(false);
            setAllStatus({ isFetching: false, succes: true, error: false });
            setAlertInfo({
                theme: "success",
                message: "Criamos a role.",
                visible: true
            });
            setShowAddRoleContent(false);
        } catch (e) {
            setAllStatus({ isFetching: false, succes: true, error: true });
            console.error("Não foi possível criar a role");
            setAlertInfo({
                theme: "danger",
                message:
                    "Ops! Não criamos a role. Tente novamente, mais tarde.",
                visible: true
            });
        }
    };

    const getBreadCrumbList = () => {
        const authBreadCrumbItem = {
            pathname: `/auth`,
            label: "Auth"
        };
        const breadCrumbList = [authBreadCrumbItem];
        return breadCrumbList;
    };

    const mountBreadCrumb = () => {
        const backToRoleInitialPage = () => {
            setIsRoleBoxVisible(false);
            setShowAddRoleContent(false);
            setIsDiffScopes(false);
            setIsDiffName(false);
            setOriginalScopes([]);
        };
        const list = getBreadCrumbList();
        return (
            <Breadcrumb>
                {list.map(item => (
                    <BreadcrumbItem key={item.pathname}>
                        <Link
                            to={item.pathname}
                            onClick={() => {
                                backToRoleInitialPage();
                            }}
                        >
                            {item.label}
                        </Link>
                    </BreadcrumbItem>
                ))}
                <BreadcrumbItem>
                    <a
                        href="#"
                        onClick={() => {
                            backToRoleInitialPage();
                        }}
                    >
                        Gerenciar roles
                    </a>
                </BreadcrumbItem>
                {showAddRoleContent && (
                    <BreadcrumbItem active>Criar role</BreadcrumbItem>
                )}
                {isRoleBoxVisible && (
                    <BreadcrumbItem active>Editar role</BreadcrumbItem>
                )}
            </Breadcrumb>
        );
    };
    const changeRoleName = e => {
        e.preventDefault();
        setValue(e);
        checkDiffName(e.target.value);
    };

    const checkDiffName = editedName => {
        const roleNameIsDiff = editedName !== role.name;
        setIsDiffName(roleNameIsDiff);
    };

    const checkScopesDiff = scopes => {
        const checkScopesDiff =
            originalScopes
                ?.map(scope => scopes.includes(scope))
                .filter(it => it === false).length > 0;
        const checkArraysSyze = originalScopes?.length !== scopes?.length;
        setIsDiffScopes(checkScopesDiff || checkArraysSyze);
    };

    const staticCellStyle = { "text-align": "center" };
    const { setBreadCrumb } = useMountBreadCrumb();

    useEffect(() => {
        setBreadCrumb(mountBreadCrumb());
    }, []);

    return (
        <React.Fragment>
            <CardCustomized small className="mb-4">
                <CardHeaderCustomized className={"border-bottom"}>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <div style={{ dispay: "block" }}>Gerenciar roles</div>
                        <div>
                            <AddButton
                                className="bt_create_role"
                                disabled={!isCreateAvailable}
                                onClick={selectAddNewRole}
                                label="Nova role"
                            />
                        </div>
                    </div>
                </CardHeaderCustomized>
                <GenericAlert
                    className="mb-3 cypreGenericAlert"
                    dismissible={() => setAlertInfo(initialAlertInfo)}
                    open={alertInfo.visible}
                    theme={alertInfo.theme}
                >
                    {alertInfo.message}
                </GenericAlert>
                {status.isFetching && <Loading />}
                {!status.isFetching && !showAddRoleContent && showAskToDelete && (
                    <DeleteBox>
                        <DeleteText>
                            Tem certeza que deseja deletar a role: {role.name}
                        </DeleteText>
                        <ButtonGroup>
                            <ResponsiblePrimaryButton
                                size="sm"
                                onClick={() => deleteRole()}
                                name="bt_delete_role"
                            >
                                Deletar
                            </ResponsiblePrimaryButton>
                            <ResponsibleSecondaryButton
                                size="sm"
                                onClick={() => setShowAskToDelete(false)}
                                name="bt_cancel_delete_role"
                            >
                                Cancelar
                            </ResponsibleSecondaryButton>
                        </ButtonGroup>
                    </DeleteBox>
                )}
                {!status.isFetching &&
                    !showAskToDelete &&
                    (showAddRoleContent || isRoleBoxVisible) && (
                        <>
                            {role.name !== "ADMIN" &&
                                role.name !== "DEVELOPER" && (
                                    <Col sm={12} md={3} lg={3}>
                                        <InputWithLabel
                                            name={"roleName"}
                                            label={"Role"}
                                            helptext={
                                                showAddRoleContent
                                                    ? "Defina um nome para a role."
                                                    : "Aletere o nome da role."
                                            }
                                            value={values.roleName}
                                            onChange={e => changeRoleName(e)}
                                        />
                                    </Col>
                                )}

                            <Col>
                                <Row>
                                    <Col sm={12} md={12} lg={12}>
                                        <UserPermissionsCardComponent
                                            title={title}
                                            permissions={role.scopes}
                                            handleUserSwitchChange={
                                                handleUserSwitchChange
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <StyledResponsiblePrimaryButton
                                disabled={!isDiffName && !isDiffScopes}
                                onClick={() =>
                                    showAddRoleContent
                                        ? createRole()
                                        : editRole()
                                }
                                name={
                                    showAddRoleContent
                                        ? "bt_create_role"
                                        : "bt_edit_role"
                                }
                            >
                                {buttonLabel}
                            </StyledResponsiblePrimaryButton>
                        </>
                    )}
                {!status.isFetching &&
                    !showAskToDelete &&
                    !showAddRoleContent &&
                    !isRoleBoxVisible && (
                        <>
                            <StyledAgGridContainer>
                                <AgGridContainerRow>
                                    <AgGridContentBox>
                                        <div
                                            style={{
                                                height: "35vh",
                                                width: "100%",
                                                overflowY: "auto",
                                                overflowX: "hidden"
                                            }}
                                            className="ag-theme-material"
                                        >
                                            <AgGridReact
                                                frameworkComponents={{
                                                    deleteLink: DeleteLink
                                                }}
                                                defaultColDef={{
                                                    editable: false,
                                                    sortable: true,
                                                    flex: 1,
                                                    minWidth: 100,
                                                    filter: true,
                                                    resizable: true
                                                }}
                                                rowClass={"ag-row-style"}
                                                context={{
                                                    askToDeleteRole,
                                                    selectRoleToEdit
                                                }}
                                                onGridReady={onGridReady}
                                                rowData={roles}
                                            >
                                                <AgGridColumn
                                                    headerName="ROLE"
                                                    field="name"
                                                    cellStyle={staticCellStyle}
                                                />

                                                <AgGridColumn
                                                    headerName=""
                                                    field="action"
                                                    minWidth={175}
                                                    cellRenderer="deleteLink"
                                                    cellStyle={staticCellStyle}
                                                />
                                            </AgGridReact>
                                        </div>
                                    </AgGridContentBox>
                                </AgGridContainerRow>
                            </StyledAgGridContainer>
                        </>
                    )}
            </CardCustomized>
        </React.Fragment>
    );
};

export default RoleView;
